import React from "react";
import "./Footer.css"; // Make sure this CSS file exists
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { useStoreSettings } from "../../../hooks/useStoreSettings";
import { useLanguage } from "../../../context/LanguageContext";
import { DEFAULT_STORE_ID } from "../../../firebase/firebase";

const Footer = () => {
  // Get store settings for dynamic content
  const { storeSettings, loading } = useStoreSettings(DEFAULT_STORE_ID);
  const { language } = useLanguage();

  // Translations for footer sections
  const translations = {
    en: {
      aboutUs: "ABOUT US",
      help: "HELP",
      followUs: "FOLLOW US",
      shippingReturns: "Shipping & Returns",
      faqs: "FAQs",
      contactUs: "Contact Us",
      privacyPolicy: "Privacy Policy",
      email: "Email",
      phone: "Phone",
      allRightsReserved: "All Rights Reserved",
      developedBy: "Developed by"
    },
    ar: {
      aboutUs: "من نحن",
      help: "المساعدة",
      followUs: "تابعنا",
      shippingReturns: "الشحن والإرجاع",
      faqs: "الأسئلة الشائعة",
      contactUs: "اتصل بنا",
      privacyPolicy: "سياسة الخصوصية",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      allRightsReserved: "جميع الحقوق محفوظة",
      developedBy: "من تطوير"
    }
  };

  const t = translations[language] || translations.en;

  // Get social media icon based on platform
  const getSocialIcon = (platform) => {
    switch (platform.toLowerCase()) {
      case 'facebook':
        return <FaFacebookF />;
      case 'instagram':
        return <FaInstagram />;
      case 'twitter':
        return <FaTwitter />;
      case 'tiktok':
        return <FaTiktok />;
      default:
        return <FaFacebookF />; // Default fallback
    }
  };

  // Render social media links
  const renderSocialIcons = () => {
    if (!storeSettings?.socialMedia) {
      return (
        <>
          <a href="#" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
          <a href="#" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="#" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
          <a href="#" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
        </>
      );
    }

    return Object.entries(storeSettings.socialMedia)
      .filter(([platform, url]) => url && url.trim() !== '')
      .map(([platform, url]) => (
        <a
          key={platform}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          title={platform}
        >
          {getSocialIcon(platform)}
        </a>
      ));
  };

  if (loading) {
    return (
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">Loading...</div>
        </div>
      </footer>
    );
  }
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info */}
        {/* Company Info */}
        <div className="footer-section about-us-section">
          <h3>{t.aboutUs}</h3>
          <p>
            {storeSettings?.multilingualContent?.[language]?.name ||
              storeSettings?.name}
          </p>

          {storeSettings?.address && <p>{storeSettings.address}</p>}
        </div>


        {/* Quick Links */}
        <div className="footer-section">
          <h3>{t.help}</h3>
          <ul>
            <li><a href="/contact">{t.contactUs}</a></li>
          </ul>
        </div>

        {/* Social Media */}
        <div className="footer-section">
          <h3>{t.followUs}</h3>
          <div className="social-icons">
            {renderSocialIcons()}
          </div>
          {storeSettings?.email && (
            <div className="footer-contact-info">
              <p>{t.email}: {storeSettings.email}</p>
            </div>
          )}
          {storeSettings?.phone && (
            <div className="footer-contact-info">
              <p>{t.phone}: {storeSettings.phone}</p>
            </div>
          )}
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>© 2025 {
          storeSettings?.multilingualContent?.[language]?.name ||
          storeSettings?.name ||
          ""
        } {t.allRightsReserved}</p>
        <p className="developer-credit">
          {t.developedBy} <a href="https://raffak.store" target="_blank" rel="noopener noreferrer" className="developer-link">Raffak.store</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
